export default __webpack_public_path__ + "static/media/img4.b52a640b.png";